import { atom } from 'jotai';

/**
 * UI context for the current chat turn — e.g. the recon run/file the user is
 * viewing on the Reconciliation Monitor. Pages that embed the ChatBot set this;
 * `useChat` attaches it to outbound messages so the agent can resolve "this run"
 * without the user naming an upload id.
 */
export interface ChatUiContext {
  uploadId?: number;
  fileName?: string;
  fundName?: string;
  period?: string;
  status?: string;
}

export const ChatUiContextAtom = atom<ChatUiContext | null>(null);
